import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { chainLpcLppSupplierQueryKeys } from './chainLpcLppSupplierQueryKeys';

export function useGetChainLpcLppSupplierChains(dateFrom: string | undefined, dateTo: string | undefined) {
  return useQuery({
    queryKey: chainLpcLppSupplierQueryKeys.chainsList(dateFrom ?? '', dateTo ?? ''),
    queryFn: async ({ signal }) => {
      if (!dateFrom || !dateTo) {
        throw new Error('Chain LPC-LPP supplier chains list requires dateFrom and dateTo');
      }
      const res = await PriceParrotService.getChainLpcLppSupplierChains(
        { date_from: dateFrom, date_to: dateTo },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(dateFrom && dateTo),
  });
}
